<div class="px-4 pb-4 border-bottom-1 surface-border">
    <span class="p-input-icon-left flex">
        <i class="pi pi-search"></i>
        <input
            type="text"
            pInputText
            class="w-full outline-none"
            placeholder="{{ 'default-cm-search' | translate: 'Search' }}"
            [(ngModel)]="searchText"
            (input)="onSearch()"
        />
    </span>
</div>
@if (selectedFilterType === 'filters') {
    <div class="flex px-4 py-3">
        <div class="border-1 border-round-md surface-border w-full">
            <form [formGroup]="myForm">
                <p-table
                    styleClass="border-round-top-md overflow-hidden"
                    [scrollable]="true"
                    [value]="filteredSelectedArray"
                >
                    <ng-template pTemplate="header">
                        <tr class="text-sm">
                            <th class="min-width-17rem">{{ 'default-cm-filterName' | translate: 'Filter Name' }}</th>
                            <th class="min-width-17rem">{{ 'default-cm-values' | translate: 'Values' }}</th>
                            <th pFrozenColumn alignFrozen="right" class="text-center">
                                {{ 'default-cm-action' | translate: 'Action' }}
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-index="rowIndex">
                        <tr>
                            <td>
                                <p-dropdown
                                    [options]="getAvailableFields(index)"
                                    dataKey="name"
                                    optionLabel="label"
                                    appendTo="body"
                                    styleClass="height-40 w-full"
                                    [filter]="true"
                                    filterBy="langValue"
                                    autoWidth="false"
                                    [ngModel]="filteredSelectedArray[index]"
                                    [ngModelOptions]="{ standalone: true }"
                                    (onChange)="onFilterChange($event, index)"
                                    (onShow)="onDropdownOpen()"
                                    placeholder="Select"
                                    (onHide)="onDropdownClose()"
                                    class="flex flex-1"
                                >
                                    <ng-template pTemplate="item" let-item>
                                        <span>{{ item.label | translateConfig: item.label }}</span>
                                    </ng-template>
                                    <ng-template pTemplate="selectedItem" let-item>
                                        <span>{{ item.label | translateConfig: item.label }}</span>
                                    </ng-template>
                                    <ng-template pTemplate="empty">
                                        <img src="assets/icons/no-result-found.svg" alt="" />
                                        <p class="text-sm text-medium py-2">
                                            {{ 'default-cm-noResultFound' | translate: 'No results found' }}
                                        </p>
                                    </ng-template>
                                </p-dropdown>
                            </td>

                            <td>
                                <div class="flex flex-1 align-items-center w-full">
                                    @switch (filteredSelectedArray[index].type) {
                                        @case ('date-range') {
                                            <app-filter-date-range
                                                [formGroup]="myForm"
                                                [controlName]="filteredSelectedArray[index].name"
                                                [dateFormat]="filteredSelectedArray[index].filterOptions.dateFormat"
                                                [label]="
                                                    filteredSelectedArray[index].filterOptions.label | translateConfig
                                                "
                                                [hide]="false"
                                                class="w-full"
                                            ></app-filter-date-range>
                                        }
                                        @case ('number-range') {
                                            <app-filter-number-range
                                                [formGroup]="myForm"
                                                [controlName]="filteredSelectedArray[index].name"
                                                class="w-full"
                                            ></app-filter-number-range>
                                        }
                                        @case ('search') {
                                            <app-filter-search-range
                                                [formGroup]="myForm"
                                                [controlName]="filteredSelectedArray[index].name"
                                                class="w-full"
                                            ></app-filter-search-range>
                                        }
                                        @case ('enum') {
                                            <app-filter-enum
                                                [formGroup]="myForm"
                                                [enumInput]="filteredSelectedArray[index].filterOptions.options"
                                                [controlName]="filteredSelectedArray[index].name"
                                                [autocomplete]="true"
                                                class="w-full"
                                            ></app-filter-enum>
                                        }
                                        @case ('boolean') {
                                            <app-filter-enum
                                                [formGroup]="myForm"
                                                [enumInput]="filteredSelectedArray[index].filterOptions.options"
                                                [controlName]="filteredSelectedArray[index].name"
                                                [autocomplete]="true"
                                                class="w-full"
                                            ></app-filter-enum>
                                        }
                                    }

                                    @if (['enum', 'search'].includes(filteredSelectedArray[index].type)) {
                                        <div [formGroup]="myForm">
                                            <div
                                                [formGroupName]="filteredSelectedArray[index].name"
                                                class="gap-2 flex ml-2"
                                            >
                                                <p-checkbox
                                                    binary="true"
                                                    formControlName="_exactMatch"
                                                    inputId="exactMatch_{{ filteredSelectedArray[index].name }}"
                                                ></p-checkbox>
                                                <label
                                                    [for]="'exactMatch_' + filteredSelectedArray[index].name"
                                                    pTooltip="{{
                                                        'default-cm-exactMatchTooltip'
                                                            | translate
                                                                : 'Enable for exact matching, disable for flexible/partial matching'
                                                    }}"
                                                    tooltipPosition="right"
                                                    class="cursor-pointer text-sm max-w-5rem text-overflow-ellipsis white-space-nowrap"
                                                >
                                                    {{ 'default-cm-exactMatch' | translate: 'Exact Match' }}
                                                </label>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </td>

                            <td pFrozenColumn alignFrozen="right">
                                <div class="flex justify-content-center align-items-center">
                                    <img
                                        src="assets/icons/delete-button.svg"
                                        alt="delete"
                                        class="cursor-pointer"
                                        (click)="onRemoveFilter(index)"
                                    />
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </form>

            @if (!selectedFilterArray.length) {
                <div class="w-full text-center py-4">
                    <img src="assets/images/no-filter.svg" alt="" />
                    <div class="flex justify-content-center align-items-center">
                        <p class="font-normal text-lg text-gray-300">
                            {{
                                'default-admin-filterAddsDescription' | translate: 'Add Filters you want in the table,'
                            }}
                        </p>
                        <p-button
                            [text]="true"
                            styleClass="shadow-none text-lg border-none text-primary-700 font-bold px-1"
                            [outlined]="true"
                            label="{{ 'default-admin-filters-add' | translate: 'Add Filter' }}"
                            (onClick)="onAddFilter()"
                        ></p-button>
                    </div>
                </div>
            } @else {
                <div class="border-blue-50 surface-100">
                    <p-button
                        styleClass="py-3"
                        [outlined]="true"
                        [text]="true"
                        icon="pi pi-plus"
                        label="{{ 'default-admin-filters-add' | translate: 'Add Filter' }}"
                        (onClick)="onAddFilter()"
                    ></p-button>
                </div>
            }
        </div>
    </div>
} @else {
    @if (additionalFiltersSearchData.length) {
        <div
            class="px-4 flex align-content-center py-3 border-bottom-1"
            style="border-color: var(--alpha-background-surface-hover-color)"
            [ngClass]="{ 'surface-100': selectAll }"
        >
            <p-checkbox
                [binary]="true"
                label="{{ 'default-cm-select-all' | translate: 'Select All' }}"
                [(ngModel)]="selectAll"
                (onChange)="onSelectAll()"
            ></p-checkbox>
        </div>
    }
    <div class="overflow-auto">
        @for (item of additionalFiltersSearchData; track $index) {
            <div
                class="px-4 flex align-content-center justify-content-between py-3 border-bottom-1"
                style="border-color: var(--alpha-background-surface-hover-color)"
                [ngClass]="{ 'surface-100': item.checked }"
                (click)="onSelectAdditionalFilter(item)"
            >
                <div
                    [pTooltip]="
                        item.disabled
                            ? ('default-admin-filter-additionalFilterDisabledTooltip'
                              | translate
                                  : 'To remove the selection, please clear the configured filter from the Default corner.')
                            : ''
                    "
                    tooltipPosition="left"
                >
                    <p-checkbox
                        [binary]="true"
                        [(ngModel)]="item.checked"
                        [disabled]="item.disabled"
                        (onChange)="onSelectAdditionalFilter(item)"
                    ></p-checkbox>
                    <label class="px-3">{{ item.label | translateConfig: item.label }}</label>
                </div>
            </div>
        }
    </div>
}
